import { RoleModuleForm } from "models/roleModule";
import axiosClient from "./axiosClient";
import { ApiResponse, RemovePayload } from "models";

const roleModuleApi = {
  getModuleList(data: any): Promise<any> {
    const url = `/permission/getAllPermissions?limit=${
      data.limit || ""
    }&page=${data.page || ""}&search=${
      data.search || ""
    }&sortField=${data.sortName || ""}&sortType=${data.sortType || ""}`;
    return axiosClient.get(url);
  },

  getAllModuleList(data: any): Promise<any> {
    const url = "/permission/getAllPermissions?disablePagination=true";
    return axiosClient.get(url);
  },

  addModule(data: any): Promise<ApiResponse> {
    const url = `/permission/createPermission`;
    return axiosClient.post(url, data, {
      // headers: {
      //   "Content-Type": "multipart/form-data",
      // },
    });
  },

  updateModule(data: any): Promise<ApiResponse> {
    const url = `/permission/updatePermission`;
    return axiosClient.put(url, data);
  },

  deleteModule(data: RemovePayload): Promise<ApiResponse> {
    const url = `/permission/removePermission?id=${data._id}`;
    return axiosClient.delete(url);
  },

  // getImageUrl(data: ImageUrlData): Promise<ApiResponse> {
  //   const url = `/settings/uploadImage`;
  //   return axiosClient.post(url, data, {
  //     headers: {
  //       "Content-Type": "multipart/form-data",
  //     },
  //   });
  // },

  //   getDocumentUrl(data: DocumentUrlData): Promise<ApiResponse> {
  //     const url = `/settings/uploadImage`;
  //     return axiosClient.post(url, data, {
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //       },
  //     });
  //   },
};

export default roleModuleApi;
